var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _path, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirtyEnergyNoSmoke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 946 410.1",
    style: {
      enableBackground: "new 0 0 946 410.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000001644560388189795360000010849936034087971982_);}\n\t.st1{fill:#E0E6E9;}\n\t.st2{fill:#D1D9DE;}\n\t.st3{fill:#C2CDD2;}\n\t.st4{fill:#9CB3B0;}\n\t.st5{fill:#809992;}\n\t.st6{fill:#DCDFE4;}\n\t.st7{fill:#EAEBEE;}\n\t.st8{fill:#D2D5DD;}\n\t.st9{fill:#DCDFE3;}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#EBECF3;}\n\t.st11{fill:#CAD2DE;}\n\t.st12{fill:#EFF0F7;}\n\t.st13{fill:#FF6B37;}\n\t.st14{fill:#C7CFDB;}\n\t.st15{fill:#ECEDF3;}\n\t.st16{fill:#FA6A37;}\n\t.st17{fill:#DBDFE8;}\n\t.st18{fill:#F5F5F8;}\n\t.st19{fill:#FF9773;}\n\t.st20{fill:#475867;}\n\t.st21{fill:#D4DCDF;}\n\t.st22{fill:#B9C9C8;}\n\t.st23{fill:#A6B8B3;}\n\t.st24{fill:#B7BCCE;}\n\t.st25{fill:#E65F38;}\n\t.st26{fill:#415062;}\n\t.st27{fill:#FFFFFF;}\n\t.st28{fill:#ADB4BD;}\n\t.st29{fill:#B9C0CA;}\n\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:#B9C0CA;}\n\t.st31{fill:#A8ACB7;}\n\t.st32{fill:#E6E7EB;}\n\t.st33{fill:#F46838;}\n\t.st34{fill:#C5CAD2;}\n\t.st35{fill:#C0C6D2;}\n\t.st36{fill:#E1E2E9;}\n\t.st37{fill:#EF6738;}\n\t.st38{fill:#C5CCD7;}\n\t.st39{fill:#E9EAEF;}\n\t.st40{fill:#F86937;}\n\t.st41{fill:#85955F;}\n\t.st42{fill:#4D4846;}\n\t.st43{fill:#607049;}\n\t.st44{fill:#454A3C;}\n\t.st45{fill:#2F404A;}\n\t.st46{fill:#A2A8B1;}\n\t.st47{fill:#27333B;}\n\t.st48{fill:#394652;}\n\t.st49{fill:#404041;}\n\t.st50{fill:#5B6E80;}\n\t.st51{fill:#24343D;}\n\t.st52{fill:#212E3D;}\n\t.st53{fill:#526379;}\n\t.st54{fill-rule:evenodd;clip-rule:evenodd;fill:#2F404A;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 946,
    height: 410
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(-136 490.567)",
    style: {
      clipPath: "url(#SVGID_00000134934461097806804390000004187508087532562867_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    transform: "translate(544.271 -206.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    className: "st1",
    d: "M0,0h-15.5c0.4,5.1,0.9,10.1,1.5,14.8c0.3,2.9,0.7,5.9,1.1,8.7h5.3v5.8H0V0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    transform: "translate(632.988 -239.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    className: "st1",
    d: "M0,0h-0.2c0,2.1,0.1,4.3,0.1,6.6H0V0z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    transform: "translate(677.118 -296.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    className: "st1",
    d: "M0,0h-25v103.8h8.8v5.2h11.8v-7.1H0V0z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    transform: "translate(684.823 -253.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    className: "st1",
    d: "M0,0h-2.3v58.8h1L0,0z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    transform: "translate(660.989 -192.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    className: "st1",
    d: "M0,0h-17.1v42.7h6.3V31.2l-2.4-1.3l11.6-4.2V5.2H0V0z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    transform: "translate(1013.428 -104.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    className: "st1",
    d: "M0,0h-28v0.2l17.7,3.7L0,6.5V0z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    transform: "translate(866.644 -252.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    className: "st1",
    d: "M0,0h-28.5v65.4l1.1,0.7h2.7v1.8L0,84.7V0z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    transform: "translate(900.711 -194.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    className: "st1",
    d: "M0,0h-17.3v37.7l1.9,1.3v22.1h14.7V29.6H0V0z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    transform: "translate(953.683 -224.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    className: "st1",
    d: "M0,0h-53v59.8h30.2v46.9h8.4V84H0V0z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    transform: "translate(730.172 -268.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    className: "st1",
    d: "M0,0h-7.6v43.4H-1L0,0z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    transform: "translate(301.927 -168.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    className: "st1",
    d: "M0,0h-28.4v45.8h8.9v3.7c3.5,0.4,7.1,1,10.6,1.6V35.2H0V0z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    transform: "translate(333.702 -206.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    className: "st1",
    d: "M0,0h-25v72.7h5.8V49H0V0z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    transform: "translate(350.151 -157.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    className: "st1",
    d: "M0,0h-35.7v23.7h6.7v8.7H0V0z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    transform: "translate(321.197 -133.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    className: "st1",
    d: "M0,0h-28.2v15.9c1.9,0.3,3.9,0.7,5.7,1.1c1.1,0.2,2.1,0.4,3.2,0.6V8.7H0V0z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    transform: "translate(368.883 -184.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    className: "st1",
    d: "M0,0h-18.7v59.6h12.4V36.2H0V0z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    transform: "translate(422.415 -239.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    className: "st1",
    d: "M0,0h-41.7v91.8h13.1V62.7h27.7c0.3-2.2,0.6-4.5,0.9-6.8C0,55.9,0,0,0,0z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    transform: "translate(393.78 -148.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    className: "st1",
    d: "M0,0h-31.3v23.4h13.5C-11.5,22.2-5.5,21,0,19.9V0z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    transform: "translate(282.446 -122.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    className: "st1",
    d: "M0,0h-17.9v3.4c2.4-0.3,4.8-0.5,7.2-0.5C-7.1,3-3.5,3.2,0,3.7V0z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    transform: "translate(548.885 -176.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    className: "st1",
    d: "M0,0h-4.6v19.7h2.1c0.7-4.8,1.4-9.8,2-14.9C-0.4,3.2-0.2,1.6,0,0"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    transform: "translate(544.271 -176.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    className: "st2",
    d: "M0,0h-7.6v16.9c1.7,0.8,3.3,1.8,4.9,2.8H0V0z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    transform: "translate(546.354 -157.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    className: "st2",
    d: "M0,0h-4.8c0.7,0.5,1.4,1,2,1.5l2.6-0.6C-0.1,0.5,0,0.3,0,0"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    transform: "translate(770.038 -176.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    className: "st2",
    d: "M0,0h-3.5v3.8L-0.1,3L0,0z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    transform: "translate(643.906 -233.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    className: "st1",
    d: "M0,0h-10.9v2.4c0.5,17.8,1.5,40.5,3.5,58.1v-20H0V0z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    transform: "translate(632.988 -233.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    className: "st2",
    d: "M0,0L0,0c0,0.8,0,1.6,0,2.4V0z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    transform: "translate(643.906 -192.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    className: "st2",
    d: "M0,0h-7.4v20c0,0.3,0.1,0.5,0.1,0.8c0.9,8,2,15.5,3.1,22.7L0,46.2V0z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    transform: "translate(650.176 -149.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    className: "st2",
    d: "M0,0h-6.3v3.5l0.4,0.3H0V0z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    transform: "translate(682.482 -194.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    className: "st1",
    d: "M0,0h-5.4v7.1h2.5v13.3l2.9-1V0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    className: "st2",
    d: "M677.1-194.6h-4.3v7.1h4.3V-194.6z"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    transform: "translate(683.485 -194.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    className: "st2",
    d: "M0,0h-1v19.3l0.6-0.2L0,0z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    transform: "translate(722.527 -224.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    className: "st1",
    d: "M0,0h-4.2l0.8,36.4L0,35.1V0z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    transform: "translate(729.184 -224.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    className: "st2",
    d: "M0,0h-6.7v35.1l5.9-2.1L0,0z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    transform: "translate(528.33 -268.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    className: "st1",
    d: "M0,0h-2.6C-2.2,16.4-1.5,37.5,0,56.8V0z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    transform: "translate(974.395 -140.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    className: "st3",
    d: "M0,0h-35.1v22.7h11v6.6L-11,32v-2.4H0V0z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    transform: "translate(930.88 -164.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    className: "st3",
    d: "M0,0h-30.9v31.6h23.7v15.3H0V0z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    transform: "translate(923.718 -133.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    className: "st3",
    d: "M0,0h-38.4v6.3c2.1,0,3.4,0.1,3.4,0.1l27.5,8.4l2.3,0.5H0V0z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    transform: "translate(950.268 -118.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    className: "st3",
    d: "M0,0h-31.8L0,6.6V0z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    transform: "translate(822.147 -186.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    className: "st3",
    d: "M0,0h-22.8l0.1,5.6L0,0 M19.7,0H17l2.7,1.9V0z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    transform: "translate(766.579 -248.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    className: "st3",
    d: "M0,0h-8l1.7,76.7L0,75.2V0z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    transform: "translate(985.447 -111.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    className: "st3",
    d: "M0,0h-22.1v2.4L0,7V0z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    transform: "translate(650.176 -146.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    className: "st3",
    d: "M0,0h-5.9l1.1,0.7C-3.2,0.6-1.6,0.5,0,0.3V0z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    transform: "translate(375.996 -124.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    className: "st3",
    d: "M0,0h-74.1v8.9c5.4,1.2,10.8,2.1,16.3,2.7C-40.4,7.8-18.9,3.7,0,0"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    transform: "translate(536.68 -182.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    className: "st3",
    d: "M0,0h-5.3c1,7.6,2.1,14.8,3.2,21.7c0.7,0.3,1.4,0.6,2.1,1L0,0L0,0z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    transform: "translate(421.487 -177.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    className: "st3",
    d: "M0,0h-27.7v49c7.6-1.5,14.2-2.8,19.2-3.9l3.1-12.7C-3.5,22.5-1.6,11.7,0,0"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    transform: "translate(679.583 -187.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    className: "st3",
    d: "M0,0h-20.2v20.5L0,13.3V0z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    transform: "translate(229.794 -98.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    className: "st4",
    d: "M0,0l-93.8,18.4h946l-78.9-20l-87-18L658.9-28c0,0-24.2-1.1-32.3,4.8s-87.8-3.9-87.8-3.9 s-32.6-9.5-38.7-10.7s-53-13.4-75.6-9.7c-10.3,1.7-20.8,1.2-31,0.8c-12.3-0.6-24.2-1.1-34.9,2c-19.7,5.7-62.8-3.6-76.8-7.4 s-82.1,13.3-89,16.5S70.1-12.6,55.6-5.7S0,0,0,0"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    transform: "translate(207.137 -105.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    className: "st5",
    d: "M0,0l-35.6,24.6H869l-18.7-12.1L740,1.4l-34.7-5.1c0,0-30.7-0.7-40.9,2.9 S553.3-3.1,553.3-3.1S496.4,2.7,488.7,2s-51.5-19.7-80-17.5c-13,1-26.2,0.7-39.2,0.5c-15.5-0.3-30.6-0.7-44.2,1.2 c-24.9,3.5-79.4-2.2-97.1-4.5s-103.9,8.1-112.7,10c-4,0.9-13.3-1.1-24-3.1c-12.4-2.4-26.5-4.7-36.4-2.4C36.8-9.5,0,0,0,0"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    transform: "translate(379.564 -490.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    className: "st6",
    d: "M0,0c-42.8,0-75.6,6-75.6,14.5c0,5.4,13.2,10.6,33.8,14.4c-20.2,1.5-34,5.2-34,9.9 c-0.1,6.9,29.2,13.3,65.4,14.5c2,0.1,3.9,0.1,5.9,0.1C9.3,45,79.7,38.9,160.2,38.9c8,0,16,0.1,24.2,0.2 c7.4,0.1,14.5,0.3,21.5,0.5c0-0.2,0-0.4,0-0.5c0.1-9.4-40.1-18.3-89.8-19.8c-4.1-0.1-8.1-0.2-12-0.2c-2.8-9-41.8-17.3-89.6-18.8 C9.5,0.1,4.7,0,0,0"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    transform: "translate(500.849 -410.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    className: "st7",
    d: "M0,0c-46.4,3.4-81,11.1-84,19.2c-5,0-10,0.1-15.2,0.3c-62.9,1.9-113.8,11.7-113.7,21.9 c0.1,9,40,15.3,92.7,15.3c6.9,0,14-0.1,21.3-0.3c31.4-1,59.8-3.9,80.3-7.8c9,4.4,33.5,7.3,63.8,7.3c5,0,10.2-0.1,15.5-0.2 c45.8-1.4,82.9-8.6,82.8-16c0-5.1-17.4-8.9-43-10.5c23.8-3.8,39.8-8.9,42.4-14.2h-0.8C66.2,13.8,9.6,7.5,0,0"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    transform: "translate(585.328 -451.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    className: "st7",
    d: "M0,0c-1.4,8.2-33.7,14-75.6,14c-4.7,0-9.5-0.1-14.4-0.2c-24.8-0.8-47.2-3.4-63.5-6.9 c-7.3,4.2-27.4,7-52.2,7c-1.5,0-3.1,0-4.7,0c-0.2,0.1-0.5,0.3-0.7,0.4c-12.6,9.1,45.7,17.6,131.6,19.5c-1.7,0.6-3.3,1.3-4.8,2.3 c-2.2,1.6-2.3,3.2-0.3,4.8c9.4-0.7,19.2-1.2,29.4-1.5c7.3-0.2,14.4-0.3,21.2-0.3c52.7,0,92.6,6.3,92.7,15.3 c0,0.5-0.1,1.1-0.4,1.5c7.8,0.1,15.6,0.2,23.3,0.2c81.8,0,153.3-6.2,165.4-14.9c6.5-4.7-6-9.3-31.6-12.9 c51.4-0.8,93.7-5.1,101.5-10.7c9.7-6.9-36.6-13.4-103.3-14.4c-5.9-0.1-11.8-0.1-17.6-0.1c-38.9,0-74.6,1.9-97.1,5 C77.6,4.2,42.7,1.2,0,0"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1210",
    transform: "translate(539.695 -451.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    className: "st8",
    d: "M0,0c-80.4,0-150.9,6-164.7,14.5c1.6,0,3.1,0,4.7,0c24.7,0,44.8-2.8,52.2-7 c16.2,3.6,38.7,6.2,63.5,6.9c4.9,0.1,9.7,0.2,14.4,0.2c41.9,0,74.2-5.8,75.6-14c-7-0.2-14.1-0.4-21.5-0.5C16,0.1,8,0,0,0"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    transform: "translate(551.471 -412.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    className: "st9",
    d: "M0,0c-6.9,0-14,0.1-21.2,0.3c-10.2,0.3-20,0.8-29.4,1.5C-41,9.3,15.6,15.6,91.5,16.7h0.8 c0.2-0.5,0.4-1,0.4-1.5C92.6,6.3,52.7,0,0,0"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1213",
    transform: "translate(479.649 -303.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    className: "st10",
    d: "M0,0c3.8,0,6.9,3.1,7,7c0,3.9-3.1,7.1-7,7.1l0,0c-3.9,0-7.1-3.2-7.1-7.1C-7,3.1-3.9,0,0,0"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    transform: "translate(492.635 -310.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    className: "st10",
    d: "M0,0c2,0,3.6,1.6,3.6,3.6l0,0c0,2-1.6,3.6-3.6,3.6l0,0c-2,0-3.6-1.6-3.6-3.6l0,0 C-3.6,1.6-2,0,0,0L0,0"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    transform: "translate(453.802 -316.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    className: "st10",
    d: "M0,0c2,0,3.6,1.5,3.6,3.5S2,7.1,0,7.1l0,0c-2,0-3.6-1.6-3.6-3.6l0,0C-3.6,1.5-2,0,0,0"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    transform: "translate(526.784 -382.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    className: "st10",
    d: "M0,0c3.9,0,7.1,3.1,7.1,7S3.9,14.1,0,14.1C-3.9,14-7,10.8-7,7C-6.9,3.1-3.8,0,0,0"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    transform: "translate(450.722 -385.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_942_00000004536918746047182930000000145197133979867534_",
    className: "st10",
    d: "M0,0"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    transform: "translate(487.015 -287.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    className: "st10",
    d: "M0,0c1.5,0,2.7,1.3,2.7,2.8c0,0,0,0,0,0.1c0,1.5-1.2,2.7-2.7,2.8c-1.6,0-2.8-1.3-2.8-2.8 C-2.9,1.3-1.7,0-0.1,0H0"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    transform: "translate(437.267 -300.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    className: "st11",
    d: "M0,0l0.9-26.4l0,0c0-0.2,0.1-0.4,0.5-0.6c1.1-0.5,2.4-0.5,3.5-0.1c0.6,0.2,0.9,0.5,0.9,0.8 l0,0L6.8,0H0z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    transform: "translate(440.681 -325.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    className: "st12",
    d: "M0,0c-1.4,0-2.5,0.4-2.5,0.9v-1.2c0-0.5,1.1-0.9,2.5-0.9s2.5,0.4,2.5,0.9v1.2 C2.5,0.4,1.4,0,0,0"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1223",
    transform: "translate(440.681 -326.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    className: "st13",
    d: "M0,0c-1.4,0-2.5,0.4-2.5,0.9v-1.2c0-0.5,1.1-0.9,2.5-0.9s2.5,0.4,2.5,0.9v1.2 C2.5,0.4,1.4,0,0,0"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    transform: "translate(441.146 -325.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    className: "st14",
    d: "M0,0v9.9C0.5,9.6,1.1,9.3,1.7,9L1.4,0.3C0.9,0.1,0.5,0,0,0"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1225",
    transform: "translate(441.15 -326.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    className: "st15",
    d: "M0,0c0,0.1,0,0.1,0,0.2v0.9c0.5,0,0.9,0.1,1.4,0.3V0.3C0.9,0.1,0.5,0,0,0"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1226",
    transform: "translate(441.82 -327.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    className: "st16",
    d: "M0,0c-0.6,0-0.7,0.3-0.7,0.6c0.5,0,0.9,0.1,1.3,0.3V0.8C0.7,0.4,0.7,0,0,0"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    transform: "translate(439.531 -325.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    className: "st17",
    d: "M0,0c-0.2,0-0.5,0.1-0.7,0.2l-0.4,11.2c0.3-0.2,0.6-0.4,0.9-0.6L0,0z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    transform: "translate(439.543 -326.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    className: "st18",
    d: "M0,0c-0.2,0-0.5,0.1-0.7,0.2v0.1v1.1C-0.5,1.2-0.3,1.2,0,1.1V0.2C0,0.2,0,0.1,0,0"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    transform: "translate(439.199 -327.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953_00000007387433990632149890000000558185617930977465_",
    className: "st19",
    d: "M0.4,0.6C0.3,0.2,0.3,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953_00000049223685553707448540000007428490706844291739_",
    className: "st19",
    d: "M0,0"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    transform: "translate(530.252 -191.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    className: "st11",
    d: "M0,0c-4.9-41.1-4.9-106.1-4.9-106.1c0-13-21.7-23.5-48.5-23.5s-48.5,10.5-48.5,23.5 c0,0-0.1,65-5,106.1c-8,66.5-22.9,110.8-22.9,110.8H22.8C22.8,110.7,7.9,66.5,0,0"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    transform: "translate(428.382 -292.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    className: "st13",
    d: "M0,0c0-13.7,21.8-24.7,48.6-24.7S97.2-13.6,97.2,0.1h0.1c0-5.6-0.4-7.2-0.4-7.2 c0-13-21.7-23.5-48.5-23.5S0-20.1,0-7.2C-0.3-4.8-0.5-2.4-0.4,0H0z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    transform: "translate(466.68 -247.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    className: "st20",
    d: "M0,0L0,0c-1.8,0-3.3-2-4.4-5.7c-1-4.2-1.6-8.5-1.5-12.9c0-9,2.1-18.6,5.9-18.6 s5.9,9.6,5.9,18.6S3.8,0,0,0 M0-35.7c-1.9,0-4.5,6.5-4.5,17.2C-4.6-14.4-4.1-10.2-3-6.1c1,3.5,2.2,4.7,3,4.7l0,0 c1.9,0,4.5-6.5,4.5-17.2S1.9-35.7,0-35.7"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    transform: "translate(479.337 -255.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    className: "st20",
    d: "M0,0c-3.6,0-9.6-2.1-15.6-5.6c-3.8-2.1-7.3-4.7-10.3-7.8c-2.7-2.8-3.7-5.1-2.8-6.6 c0.5-0.9,1.7-1.4,3.4-1.4c3.6,0,9.6,2.1,15.6,5.6c7.8,4.5,15,11.1,13.1,14.4C2.9-0.5,1.7,0,0,0 M-25.3-20 c-1.2,0-1.9,0.3-2.2,0.7c-0.4,0.7,0.1,2.4,2.6,5c3,2.9,6.4,5.5,10,7.5C-9.2-3.5-3.4-1.4,0-1.4c1.2,0,1.9-0.3,2.2-0.7 c0.9-1.6-3.4-7.2-12.6-12.5C-16.1-17.9-21.9-20-25.3-20"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    transform: "translate(454.043 -255.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    className: "st20",
    d: "M0,0L0,0c-1.7,0-2.9-0.5-3.4-1.4C-4.3-2.9-3.3-5.2-0.6-8c3.1-3,6.6-5.6,10.3-7.8 c6-3.4,11.9-5.6,15.6-5.6c1.7,0,2.9,0.5,3.4,1.4c1.9,3.3-5.3,9.9-13.1,14.4C9.6-2.1,3.6,0,0,0 M25.3-20c-3.4,0-9.2,2.1-14.9,5.4 c-3.7,2-7,4.6-10,7.5c-2.5,2.6-3,4.3-2.6,5C-2-1.7-1.2-1.4,0-1.4l0,0c3.4,0,9.2-2.1,14.9-5.4c9.2-5.3,13.6-10.9,12.6-12.5 C27.3-19.7,26.5-20,25.3-20"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    transform: "translate(469.753 -265.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    className: "st20",
    d: "M0,0c0,1.7-1.4,3.1-3.1,3.1S-6.2,1.7-6.2,0s1.4-3.1,3.1-3.1S0-1.7,0,0"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    transform: "translate(458.081 -315.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    className: "st17",
    d: "M0,0c-17.4,3.7-29.7,12.5-29.7,22.8l0,0c-0.1,15.5-0.9,66.9-5,101.5 c-0.3,2.5-0.6,4.9-0.9,7.3c-0.3,2.3-0.6,4.6-0.9,6.8c-1.6,11.7-3.5,22.5-5.3,32.4L0,0z"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    transform: "translate(458.975 -319.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    className: "st19",
    d: "M0,0c-17.9,3.4-30.6,11.9-30.6,21.8c0,0,0,1.7,0,4.6l0,0c0-10.2,12.3-19,29.7-22.8L0,0z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    transform: "translate(416.146 -144.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    className: "st21",
    d: "M0,0l-3.1,12.7l0.6-0.1C-1.7,8.6-0.8,4.4,0,0"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    transform: "translate(413.646 -132.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    className: "st22",
    d: "M0,0l-0.6,0.1l-2.2,9.1L-2,9.1C-1.3,6.2-0.7,3.2,0,0"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    transform: "translate(411.671 -122.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    className: "st23",
    d: "M0,0l-0.9,0.1l-6.6,26.8h0.8C-4.8,20-2.4,10.9,0,0"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    transform: "translate(511.715 -101.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    className: "st24",
    d: "M0,0v14.6l0,0V0L0,0 M-76.8-27.7l-0.5,1.5c0.3,0,0.5,0,0.8,0 C-76.6-26.7-76.8-27.2-76.8-27.7 M-55.3-31.7c0.2,0.8,0.3,1.6,0.3,2.4c0,1-0.1,1.9-0.4,2.9l0,0c0.7-0.2,1.5-0.2,2.2-0.2 c0.5,0,1.1,0,1.6,0.1v-5.2H-55.3 M-34.6-162.9l-2.1,6.7c1.4,0.4,2.8,0.7,4.3,0.7c1.2,0,1.9-0.3,2.2-0.7 C-29.6-157.2-31.1-159.8-34.6-162.9 M-31.1-174l-1.8,5.7c2.3-2.4,3.2-4.3,2.7-5.1C-30.4-173.7-30.7-173.9-31.1-174 M-18.3-214.9 l-12.4,39.6c0.7,0.2,1.3,0.6,1.7,1.2c1.2,2-1.1,5.3-4.8,8.5l-0.4,1.2c3.9,3.4,6.4,6.7,5.1,8.8c-0.5,0.9-1.7,1.4-3.4,1.4 c-1.6,0-3.2-0.3-4.7-0.8L-73.8-37.3c1-1,2.1-1.8,3.4-2.3l0,0h0.1l0,0h0.1l0,0h0.1c1.3-0.5,2.6-0.8,4-0.8c4.6,0,8.7,2.8,10.3,7.1 c0.2,0.4,0.3,0.9,0.4,1.3l17.6-4.8c2.1-9.8,9.9-18.1,20.8-22.7l0.5-22.5v0.1v0.1v-0.1l0.1-5.2c0-0.1,0-0.3,0-0.4l0.1-3.4l0,0v-1 c0-2.1,2.9-3.7,6.6-3.7s6.6,1.7,6.6,3.7v1l0,0l0,0l0.1,3.5c0,0.1,0,0.2,0,0.3l0.1,5.2v0.1v-0.1V-82l0.4,18.8 c1.8-0.2,3.6-0.3,5.4-0.3l0,0c6.8,0,13.6,1.3,19.9,4c-1.1-6.9-2.2-14.1-3.2-21.7c-0.4-2.9-0.7-5.8-1.1-8.7 c-0.6-4.7-1-9.6-1.5-14.8c-0.2-1.8-0.3-3.6-0.4-5.5c-1.5-19.3-2.2-40.3-2.6-56.8c-0.3-12.8-0.4-22.8-0.4-26.9 C11.8-203.7-1-211.7-18.3-214.9"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    transform: "translate(494.555 -319.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    className: "st25",
    d: "M0,0l-1.1,3.6C16.2,6.8,29,14.8,30.8,24.4c0-1.4,0-2.1,0-2.1C30.8,13.9,16.3,3,0,0"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    transform: "translate(477.612 -265.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    className: "st26",
    d: "M0,0l-0.5,1.4c3.5,3.1,5,5.7,4.4,6.7c-0.2,0.5-1,0.8-2.2,0.8c-1.5,0-2.9-0.3-4.3-0.7L-3,9.5 c1.5,0.5,3.1,0.7,4.7,0.8c1.7,0,2.9-0.5,3.4-1.4C6.4,6.7,3.9,3.4,0,0"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    transform: "translate(481.036 -276.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    className: "st26",
    d: "M0,0l-0.4,1.3C0,1.4,0.3,1.6,0.5,1.9C1,2.8,0.1,4.7-2.2,7L-3,9.7c3.7-3.2,6-6.5,4.8-8.5 C1.3,0.6,0.7,0.2,0,0"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1247",
    transform: "translate(581.743 -292.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_971_00000049216240700119706020000014556348499386810032_",
    className: "st10",
    d: "M0,0"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1252",
    transform: "translate(598.979 -373.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    className: "st10",
    d: "M0,0c1.6,0,2.9-1.3,2.9-2.9l0,0c0-1.6-1.3-2.8-2.9-2.8c-1.5,0-2.7,1.2-2.8,2.8 C-2.8-1.3-1.6,0,0,0"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1253",
    transform: "translate(586.212 -274.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    className: "st10",
    d: "M0,0c-1.2,0-2.1,1-2.1,2.2l0,0c0,1.2,0.9,2.2,2.1,2.2s2.2-1,2.2-2.2C2.3,1,1.3,0,0.1,0H0"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1254",
    transform: "translate(559.839 -262.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    className: "st11",
    d: "M0,0l0.8-21.8l0,0c0-0.2,0.1-0.4,0.4-0.5c0.9-0.4,2-0.4,2.9-0.1c0.5,0.2,0.7,0.4,0.8,0.6 l0,0L5.6,0H0z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    transform: "translate(562.658 -282.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    className: "st12",
    d: "M0,0c-1.2,0-2.1,0.3-2.1,0.7v-1C-2.1-0.7-1.1-1,0-1s2.1,0.3,2.1,0.7v1C2.1,0.3,1.2,0,0,0"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    transform: "translate(562.658 -283.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    className: "st13",
    d: "M0,0c-1.1,0-2.1,0.3-2.1,0.7v-1C-2-0.7-1.1-1,0-1s2,0.3,2,0.7v1C2.1,0.3,1.1,0,0,0"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1257",
    transform: "translate(563.042 -282.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    className: "st14",
    d: "M0,0v8.2C0.5,8,0.9,7.7,1.4,7.5L1.1,0.2C0.8,0.1,0.4,0,0,0"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1258",
    transform: "translate(563.045 -283.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    className: "st15",
    d: "M0,0c0,0.1,0,0.1,0,0.2V1c0.4,0,0.8,0,1.1,0.2V0.3C0.7,0.1,0.4,0,0,0"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    transform: "translate(563.599 -284.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    className: "st16",
    d: "M0,0c-0.5,0-0.5,0.2-0.6,0.5c0.4,0,0.7,0.1,1.1,0.2l0,0C0.5,0.3,0.6,0,0,0"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    transform: "translate(561.707 -282.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    className: "st17",
    d: "M0,0c-0.2,0-0.4,0.1-0.6,0.2l-0.3,9.2c0.3-0.2,0.5-0.3,0.8-0.5L0,0z"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1261",
    transform: "translate(561.717 -283.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    className: "st18",
    d: "M0,0c-0.2,0-0.4,0.1-0.6,0.2l0,0v0.9C-0.4,1-0.2,1,0,0.9V0.2C0,0.1,0,0.1,0,0"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1262",
    transform: "translate(561.435 -284.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    className: "st19",
    d: "M0,0c-0.3,0-0.3,0.3-0.3,0.6c0.2-0.1,0.4-0.1,0.6-0.2C0.3,0.2,0.2,0,0,0"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    transform: "translate(636.59 -171.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    className: "st11",
    d: "M0,0c-4-34-4-87.6-4-87.6C-4-98.3-21.9-107-44-107s-40,8.7-40,19.4c0,0-0.1,53.6-4.2,87.6 c-6.6,54.9-18.9,91.4-18.9,91.4h126C18.8,91.4,6.5,54.9,0,0"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    transform: "translate(552.506 -255.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    className: "st13",
    d: "M0,0c0-11.3,18-20.4,40.1-20.4S80.2-11.2,80.2,0h0.1c0.1-2,0-4-0.3-5.9 c0-10.7-17.9-19.4-40-19.4S0-16.6,0-5.9C-0.3-4-0.4-2-0.3,0H0z"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    transform: "translate(584.119 -218.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    className: "st20",
    d: "M0,0L0,0c-1.4,0-2.7-1.6-3.6-4.7c-0.9-3.5-1.3-7-1.3-10.6c0-7.4,1.7-15.3,4.9-15.3 s4.9,7.9,4.9,15.3S3.2,0,0,0 M0-29.5c-1.6,0-3.7,5.4-3.7,14.2C-3.8-11.8-3.3-8.4-2.5-5C-1.7-2.2-0.7-1.1,0-1.1l0,0 c1.6,0,3.7-5.4,3.7-14.2S1.6-29.5,0-29.5"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1266",
    transform: "translate(594.567 -224.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    className: "st20",
    d: "M0,0c-3,0-8-1.8-12.9-4.6c-3.1-1.7-6-3.9-8.5-6.4c-2.2-2.3-3-4.2-2.3-5.5 c0.5-0.8,1.4-1.2,2.8-1.2c3,0,7.9,1.8,12.9,4.6C-1.6-9.3,4.4-3.9,2.8-1.2C2.4-0.4,1.4,0,0,0 M-20.9-16.5c-1,0-1.6,0.2-1.8,0.6 c-0.3,0.6,0.1,1.9,2.1,4.1c2.5,2.4,5.2,4.5,8.3,6.2C-7.6-2.9-2.8-1.1,0-1.1c1,0,1.6-0.2,1.8-0.6C2.6-3.1-1-7.7-8.6-12.1 C-13.3-14.8-18.1-16.5-20.9-16.5"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    transform: "translate(573.688 -224.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    className: "st20",
    d: "M0,0c-1.4,0-2.4-0.4-2.8-1.2c-0.7-1.3,0.1-3.1,2.3-5.5C2-9.2,4.9-11.3,8-13.1 c4.9-2.8,9.9-4.6,12.9-4.6c1.4,0,2.4,0.4,2.8,1.2c1.6,2.7-4.4,8.2-10.8,11.9C7.9-1.8,3,0,0,0 M20.9-16.5 c-2.8,0-7.6,1.7-12.3,4.5c-3,1.7-5.8,3.8-8.3,6.2c-2.1,2.2-2.5,3.5-2.1,4.1C-1.6-1.4-1-1.2,0-1.2c2.8,0,7.6-1.7,12.3-4.4 c7.6-4.4,11.2-9,10.4-10.3C22.5-16.3,21.8-16.5,20.9-16.5"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1268",
    transform: "translate(586.656 -233.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    className: "st20",
    d: "M0,0c0,1.4-1.1,2.5-2.5,2.5S-5,1.4-5,0s1.1-2.5,2.5-2.5l0,0C-1.1-2.5,0-1.4,0,0"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1269",
    transform: "translate(577.022 -274.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    className: "st17",
    d: "M0,0c-14.4,3.1-24.5,10.3-24.5,18.8l0,0c-0.1,12.8-0.7,55.2-4.1,83.8 c-0.7,5.4-1.4,10.7-2.1,15.7l1.9-0.5L0,0z"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1270",
    transform: "translate(577.76 -277.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    className: "st19",
    d: "M0,0c-14.8,2.8-25.2,9.8-25.3,18c0,0,0,1.4,0,3.8l0,0c0-8.5,10.1-15.7,24.5-18.8L0,0z"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1271",
    transform: "translate(592.768 -231.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    className: "st24",
    d: "M0,0l-1.7,5.5c1.1,0.4,2.3,0.6,3.5,0.6c1,0,1.6-0.2,1.8-0.6C4.1,4.7,2.9,2.6,0,0 M2.9-9.1 L1.4-4.4c1.9-2,2.7-3.5,2.3-4.2C3.5-8.9,3.2-9.1,2.9-9.1 M13.4-42.9L3.2-10.2c0.6,0.1,1.1,0.5,1.4,1c1,1.7-0.9,4.3-3.9,7l-0.3,1 c3.2,2.8,5.3,5.6,4.3,7.3C4.2,6.9,3.2,7.3,1.8,7.3C0.5,7.2-0.8,7-2.1,6.6l-19.7,63l36.1-9L47,82.8c-1.1-7.1-2.2-14.7-3.1-22.7 c0-0.3-0.1-0.5-0.1-0.8c-2-17.6-3-40.4-3.5-58.1c0-0.8,0-1.6-0.1-2.4c-0.1-2.3-0.1-4.5-0.1-6.6c-0.2-8.5-0.2-14.9-0.2-17.9 C38.2-33.7,27.7-40.3,13.4-42.9"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1272",
    transform: "translate(607.125 -277.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    className: "st25",
    d: "M0,0l-0.9,3c14.3,2.6,24.8,9.2,26.4,17.2c0-1.1,0-1.8,0-1.8C25.4,11.5,13.4,2.5,0,0"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1273",
    transform: "translate(593.141 -233.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    className: "st26",
    d: "M0,0l-0.4,1.2c2.9,2.6,4.1,4.7,3.6,5.5C3,7.1,2.4,7.3,1.4,7.3C0.2,7.3-1,7.1-2.1,6.7 l-0.3,1.1c1.3,0.4,2.6,0.6,3.9,0.6c1.4,0,2.4-0.4,2.8-1.2C5.3,5.6,3.2,2.8,0,0"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1274",
    transform: "translate(595.967 -242.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    className: "st26",
    d: "M0,0l-0.3,1.1C0,1.2,0.3,1.3,0.4,1.6C0.8,2.3,0,3.9-1.9,5.8L-2.5,8c3.1-2.7,4.9-5.3,3.9-7 C1.1,0.5,0.6,0.1,0,0"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    transform: "translate(607.119 -171.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    className: "st27",
    d: "M0,0l-65.9,16.3L-66,90.7h65.8L0,0z"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    transform: "translate(649.18 -80.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    className: "st28",
    d: "M0,0h-42.1l0.1-90.8L0.1-62.3L0,0z"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    transform: "translate(637.136 -109.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    className: "st11",
    d: "M0,0l-62.4,4.1V29H0V0z"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1278",
    transform: "translate(677.061 -80.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    className: "st29",
    d: "M0,0h-39.9v-28.9l39.9,4V0z"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    transform: "translate(437.351 -97.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    className: "st27",
    d: "M0,0l-58.7,1.7v14.8H0V0z"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1280",
    transform: "translate(463.711 -113.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    className: "st11",
    d: "M0,0l-38,3.5v29.4H0V0z"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1281",
    transform: "translate(500.481 -212.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    className: "st30",
    d: "M0,0c-0.7,0-1.2,0.6-1.2,1.2c0,0.7,0.6,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2l0,0 C1.2,0.6,0.7,0,0,0L0,0"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1282",
    transform: "translate(505.493 -206.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    className: "st30",
    d: "M0,0c-0.9,0-1.7,0.8-1.7,1.7S-1,3.4,0,3.4l0,0c0.9,0,1.7-0.8,1.7-1.7C1.7,0.7,0.9,0,0,0"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1283",
    transform: "translate(502.355 -208.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    className: "st30",
    d: "M0,0c-0.5,0-0.9,0.4-0.9,0.9l0,0c0,0.5,0.4,0.9,0.9,0.9l0,0c0.5,0,0.9-0.4,0.9-0.9l0,0 C0.9,0.4,0.5,0,0,0L0,0"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    transform: "translate(517.357 -221.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    className: "st30",
    d: "M0,0c-0.4,0-0.7,0.2-0.9,0.5C-1-1.7-2.8-3.4-5-3.4c-0.4,0-0.9,0.1-1.3,0.2 C-7-4.3-8.3-5-9.6-5.1c-0.4-2.3-2.4-4-4.8-4c-2.7,0-4.9,2.2-4.9,4.9c0,0.6,0.1,1.2,0.3,1.7c-0.8,0.3-1.3,1-1.3,1.9 c0,1.1,0.9,2,2,2c0.8,0,1.5-0.5,1.8-1.2c0.7,0.3,1.4,0.5,2.1,0.5c0.2,0,0.3,0,0.5,0c0.1,0.3,0.2,0.5,0.4,0.7 c-1.3,0.2-2.4,1.1-2.9,2.4c-0.4-1-1.4-1.6-2.4-1.6c-1.5,0-2.6,1.2-2.7,2.7c0,1.5,1.2,2.6,2.6,2.7c0.9,0,1.8-0.5,2.3-1.3 c0.5,1.7,2,2.9,3.7,2.9c0.1,0,0.3,0,0.4,0c0.1,0.4,0.2,0.8,0.3,1.1c-0.7,0.5-1.2,1.3-1.2,2.2c0,1.5,1.2,2.6,2.6,2.6 c1.5,0,2.6-1.2,2.7-2.6l0,0c0-0.2,0-0.4,0-0.5c0.9-0.3,1.6-1,2-1.8c0.3,0.3,0.8,0.4,1.2,0.4c1.1,0,2-0.9,2-2s-0.9-2-2-2l0,0 c-0.5,0-1,0.2-1.4,0.5C-6.9,6-8,5.4-9.2,5.3c0-0.6-0.1-1.2-0.4-1.7c0.4,0,0.8-0.1,1.2-0.3c0.8,1,2,1.6,3.3,1.6 c1.8,0,3.5-1.2,4-3C-0.9,2.2-0.5,2.5,0,2.5c0.7,0,1.2-0.5,1.2-1.2l0,0C1.2,0.6,0.7,0,0,0"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1285",
    transform: "translate(511.733 -209.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    className: "st30",
    d: "M0,0c-0.5,0-0.9,0.4-0.9,0.8c0,0.5,0.4,0.9,0.9,0.9l0,0c0.5,0,0.9-0.4,0.9-0.9l0,0 C0.9,0.4,0.5,0,0,0"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    transform: "translate(494.112 -225.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    className: "st30",
    d: "M0,0c-0.9,0-1.7,0.7-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7S0.9,0,0,0"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    transform: "translate(512.476 -226.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    className: "st30",
    d: "M0,0c0.7,0,1.2-0.5,1.3-1.2c0-0.7-0.6-1.2-1.3-1.2s-1.2,0.5-1.2,1.2l0,0 C-1.2-0.6-0.7,0,0,0"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1288",
    transform: "translate(507.595 -232.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    className: "st30",
    d: "M0,0c0.5,0,0.9-0.4,0.9-0.9l0,0c0-0.5-0.4-0.8-0.9-0.8s-0.8,0.4-0.8,0.8 C-0.8-0.4-0.5,0,0,0"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    transform: "translate(503.714 -202.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    className: "st30",
    d: "M0,0c-0.4,0-0.7,0.3-0.6,0.7l0,0C-0.6,1-0.4,1.3,0,1.4c0.4,0,0.7-0.3,0.7-0.7S0.4,0,0,0 L0,0"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    transform: "translate(492.862 -80.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    className: "st28",
    d: "M0,0l2.5-111.7l0,0c0-1,0.4-2,1.2-2.7c2.2-2,6.5-2.3,9.5-0.6c1.3,0.6,2.3,1.8,2.5,3.3l0,0 L18.3,0H0z"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1291",
    transform: "translate(502.002 -186.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    className: "st12",
    d: "M0,0c-3.8,0-6.8,1.7-6.8,3.8l0.1-5.3c0-2.1,3-3.7,6.7-3.7s6.7,1.7,6.7,3.7l0.1,5.3 C6.8,1.7,3.8,0,0,0"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1292",
    transform: "translate(502.002 -191.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    className: "st13",
    d: "M0,0c-3.7,0-6.7,1.7-6.7,3.8l0.1-5.3c0-2.1,2.9-3.7,6.6-3.7s6.6,1.7,6.6,3.7l0.1,5.3 C6.7,1.7,3.7,0,0,0"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    transform: "translate(503.251 -186.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    className: "st31",
    d: "M0,0v23.3c1.4-0.3,2.8-0.6,4.2-0.8L3.7,1.1C2.6,0.5,1.3,0.1,0,0"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1294",
    transform: "translate(503.261 -191.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    className: "st32",
    d: "M0,0c0,0.3,0,0.5,0,0.8v4C1.3,4.9,2.6,5.3,3.7,6L3.6,1.1C2.5,0.5,1.3,0.1,0,0"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    transform: "translate(505.056 -194.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    className: "st33",
    d: "M0,0c-1.6,0-1.8,1.2-1.8,2.8c1.3,0.1,2.5,0.5,3.6,1.1V3.6C1.8,1.6,1.8,0,0,0"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    transform: "translate(498.923 -186.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    className: "st34",
    d: "M0,0c-0.7,0.2-1.3,0.5-1.9,0.8L-2.4,25c0.7-0.3,1.5-0.5,2.2-0.8L0,0z"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    transform: "translate(498.954 -191.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    className: "st18",
    d: "M0,0c-0.6,0.2-1.3,0.5-1.8,0.8V1l-0.1,4.6C-1.3,5.3-0.7,5,0,4.8V1C0,0.7,0,0.3,0,0"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1298",
    transform: "translate(498.032 -193.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    className: "st19",
    d: "M0,0c-0.9,0-0.9,1.5-0.9,3.3C-0.3,3,0.3,2.7,0.9,2.5C0.9,1,0.8,0,0,0"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1299",
    transform: "translate(555.883 -132.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    className: "st11",
    d: "M0,0c0-17.6-18.5-31.9-41.2-31.9S-82.5-17.7-82.5-0.1s18.4,31.9,41.2,31.9S0,17.6,0,0"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    transform: "translate(787.967 -294.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    className: "st30",
    d: "M0,0c-0.7,0-1.2,0.6-1.2,1.2l0,0c0,0.7,0.5,1.2,1.2,1.3c0.7,0,1.3-0.6,1.3-1.3 C1.3,0.6,0.7,0,0,0L0,0"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    transform: "translate(680.89 -80.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    className: "st11",
    d: "M0,0l5.7-248.8l0,0c-0.1-2.3,0.9-4.5,2.7-6c4.9-4.4,14.5-5,21.1-1.4 c3.5,1.9,5.4,4.6,5.5,7.4l0,0L40.7,0H0z"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    transform: "translate(701.262 -317.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    className: "st12",
    d: "M0,0c-8.4,0-15.2,3.8-15.2,8.6L-15-3.2c0-4.6,6.7-8.3,14.9-8.3s15,3.7,15,8.3l0.3,11.8 C15.2,3.8,8.4,0,0,0"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    transform: "translate(701.262 -328.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    className: "st13",
    d: "M0,0c-8.2,0-14.9,3.8-14.9,8.6l0.2-11.8c0-4.6,6.5-8.3,14.6-8.3s14.7,3.7,14.7,8.3 l0.2,11.8C14.9,3.8,8.2,0,0,0"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    transform: "translate(704.042 -317.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    className: "st35",
    d: "M0,0l-0.2,134.6l11.3-4.1L8.3,2.5C5.7,1.1,2.9,0.2,0,0"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    transform: "translate(704.064 -328.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    className: "st36",
    d: "M0,0c0,0.6,0,1.2,0,1.8v8.9c2.9,0.2,5.7,1.1,8.3,2.5L8,2.5C5.5,1.1,2.8,0.3,0,0"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    transform: "translate(708.066 -334.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    className: "st37",
    d: "M0,0c-3.5,0-3.9,2.6-4,6.1c2.8,0.3,5.5,1.1,8,2.5V7.9C4,3.5,4.1,0,0,0"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    transform: "translate(694.397 -316.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    className: "st17",
    d: "M0,0c-1.5,0.4-2.9,1-4.3,1.8l-3,138.1l6-2.1L0,0z"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    transform: "translate(694.466 -327.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    className: "st18",
    d: "M0,0c-1.4,0.4-2.8,1-4.1,1.8v0.5l-0.2,10.2c1.3-0.8,2.8-1.4,4.3-1.8l0-8.4C0,1.5,0,0.7,0,0 "
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    transform: "translate(692.414 -333.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    className: "st19",
    d: "M0,0c-2,0-2.1,3.2-2.1,7.3C-0.8,6.6,0.6,6,2.1,5.5C2,2.3,1.7,0,0,0"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    transform: "translate(725.901 -80.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    className: "st11",
    d: "M0,0l5.1-223l0,0c-0.1-2.1,0.8-4,2.4-5.4c4.4-3.9,13-4.5,18.9-1.2c3.1,1.7,4.8,4.2,5,6.6 l0,0L36.5,0H0z"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    transform: "translate(744.164 -293.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    className: "st12",
    d: "M0,0c-7.5,0-13.6,3.4-13.6,7.7l0.2-10.6c0-4.1,6-7.4,13.4-7.4S13.4-7,13.4-2.9l0.2,10.6 C13.6,3.4,7.5,0,0,0"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    transform: "translate(744.164 -302.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    className: "st13",
    d: "M0,0c-7.4,0-13.3,3.4-13.3,7.7l0.2-10.6c0-4.1,5.9-7.4,13.1-7.4S13.1-7,13.1-2.9l0.2,10.6 C13.3,3.4,7.4,0,0,0"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    transform: "translate(746.656 -292.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    className: "st38",
    d: "M0,0l-0.2,115.4l8.8,11.3v-4l1.4-0.4L7.4,2.3C5.1,1,2.6,0.2,0,0"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    transform: "translate(746.676 -302.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    className: "st39",
    d: "M0,0c0,0.5,0,1,0,1.6v8c2.6,0.2,5.1,1,7.4,2.3L7.2,2.3C5,1,2.5,0.2,0,0"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    transform: "translate(750.264 -308.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    className: "st40",
    d: "M0,0c-3.1,0-3.5,2.3-3.6,5.5c2.5,0.2,5,1,7.2,2.3V7.1C3.6,3.2,3.7,0,0,0"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    transform: "translate(738.009 -292.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    className: "st17",
    d: "M0,0c-1.3,0.4-2.6,0.9-3.8,1.6l-2.1,97.6l1.8-0.7l3.1,4L0,0z"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    transform: "translate(738.071 -301.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    className: "st18",
    d: "M0,0c-1.3,0.4-2.5,0.9-3.7,1.6v0.5l-0.2,9.2c1.2-0.7,2.5-1.3,3.8-1.6L0,2.1 C0,1.4,0,0.7,0,0"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    transform: "translate(736.23 -306.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    className: "st19",
    d: "M0,0c-1.8,0-1.8,2.9-1.8,6.6C-0.7,5.9,0.5,5.3,1.8,5C1.8,2.1,1.5,0,0,0"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    transform: "translate(767.849 -80.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    className: "st11",
    d: "M0,0l4.7-207l0,0c-0.1-1.9,0.8-3.8,2.2-5c4.1-3.7,12.1-4.2,17.6-1.1 c2.9,1.6,4.5,3.9,4.6,6.1l0,0L33.9,0H0z"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1346",
    transform: "translate(784.795 -277.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    className: "st12",
    d: "M0,0c-7,0-12.6,3.2-12.6,7.1l0.2-9.8c0-3.8,5.6-6.9,12.4-6.9s12.5,3.1,12.5,6.9l0.2,9.8 C12.6,3.2,7,0,0,0"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1347",
    transform: "translate(784.795 -286.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    className: "st13",
    d: "M0,0c-6.8,0-12.4,3.2-12.4,7.1l0.2-9.8c0-3.8,5.4-6.9,12.2-6.9s12.2,3.1,12.2,6.9l0.2,9.8 C12.4,3.2,6.8,0,0,0"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1348",
    transform: "translate(787.107 -277.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    className: "st14",
    d: "M0,0l-0.2,99.6L9,97.4L6.9,2.1C4.8,0.9,2.4,0.2,0,0"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1349",
    transform: "translate(787.125 -286.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    className: "st15",
    d: "M0,0c0,0.5,0,1,0,1.5v7.4c2.4,0.2,4.7,1,6.9,2.1L6.7,2.1C4.6,0.9,2.3,0.2,0,0"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1350",
    transform: "translate(790.456 -291.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    className: "st16",
    d: "M0,0c-2.9,0-3.3,2.2-3.3,5.1C-1,5.3,1.3,6,3.3,7.2V6.6C3.3,2.9,3.4,0,0,0"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    transform: "translate(779.085 -277.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    className: "st17",
    d: "M0,0c-1.2,0.3-2.4,0.8-3.5,1.5l-2.1,98l1.7,2.4l3-0.7L0,0z"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    transform: "translate(779.144 -285.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    className: "st18",
    d: "M0,0c-1.2,0.3-2.3,0.8-3.4,1.5v0.4l-0.2,8.5c1.1-0.7,2.3-1.2,3.5-1.5l0.1-7 C0,1.3,0,0.6,0,0"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    transform: "translate(777.437 -290.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    className: "st19",
    d: "M0,0c-1.7,0-1.7,2.7-1.7,6.1C-0.6,5.5,0.5,5,1.7,4.6C1.7,1.9,1.4,0,0,0"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1354",
    transform: "translate(631.298 -96.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    className: "st41",
    d: "M0,0c-1.3-1.2-3.2-1.5-4.8-0.8c-0.9-3.3-3.7-5.8-7.1-6.3c1.1-1.6,1.6-3.4,1.6-5.3 c-0.1-4.8-4-8.6-8.8-8.5l0,0c-4.5,0.2-8,3.7-8.3,8.2c-1-0.4-2-0.5-3.1-0.5c-4.8,0.2-8.5,4.2-8.3,9c0,1,0.2,1.9,0.5,2.8 c-0.8,1.4-1.2,3-1.1,4.5c0.1,4.8,4,8.6,8.8,8.5l0,0c1.4,0,2.8-0.4,4.1-1.2l0.2,0.2c2.2,2,5.6,1.9,7.6-0.3l0,0 c0.4-0.4,0.7-0.9,0.9-1.4c1.4,1,3.2,1.5,4.9,1.4c1,0,2.1-0.3,3-0.7c0.1,0.6,0.5,1.2,0.9,1.6c1.3,1.2,3.4,1.1,4.6-0.2 c0.8-0.9,1.1-2.1,0.7-3.3C-2.3,7.8-1,7.2-0.1,6.2C1.9,4.5,1.8,1.7,0,0"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    transform: "translate(610.61 -82.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    className: "st42",
    d: "M0,0c0,0.6-0.1,1.2-0.1,1.6h5.4c3.2-2.6,6.3-5.5,9-8.5c-1.1,1.2-5.8,4.2-6.7,5.1 C7.2-2,8.2-4.7,8.2-6.7c0,0-2.1,3.7-1.5,5.6C5.5-0.2,4.3,0.5,2.9,1.2C2.7-1.9,2.5-4,2.3-5.5c0-0.4,3.6-6.9,3.4-6.6 c-1.5,1.9-2.2,2.2-3.4,4.5c-0.4,0.7-1.4-5.7-1.4-5.7C0.4-13,1-8.6,0.8-7.6C0.7-6.9,0.6-6.1,0.6-5.4c-0.1,0.9-0.2,3-0.3,3.9 c-1-0.2-2.8-2.4-5.1-6.5C-4.8-8-3.1-0.9,0,0"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    transform: "translate(609.92 -80.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    className: "st42",
    d: "M0,0h2.4C-0.3-1.3-9.2-3.6-12.4-6.2C-12.4-6.2-11.2-3,0,0"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    transform: "translate(599.263 -84.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    className: "st43",
    d: "M0,0c0,0.2,0.1,0.3,0.1,0.4c0,0,0.1-0.1,0.2-0.1C0.2,0.1,0.1,0.1,0,0 M4.3-1.7 C3.6-1.1,2.9-0.4,2.1,0.4l0.2,0.1c1-0.1,2-0.4,3-0.9L5.2-0.5C4.8-0.9,4.5-1.3,4.3-1.7 M4-2.5C2.9-2.1,1.7-1.8,0.4-1.7 c-0.1,0-0.1,0-0.2,0c0,0.4-0.1,0.8-0.2,1.1c0.2,0.1,0.5,0.3,0.8,0.4C1.6-0.8,2.8-1.7,4-2.5L4-2.5 M-5.4-3.5 c-0.1,0.1-0.1,0.2-0.2,0.3c1.1,1.6,2.7,2.7,4.5,3.3c0-0.3,0-0.7,0.1-1c-0.3-0.3-0.6-0.6-0.8-1C-1.5-1.7-1.2-1.5-1-1.3 c0-0.2,0.1-0.4,0.1-0.6C-2.5-1.9-4.1-2.5-5.4-3.5"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    transform: "translate(601.368 -84.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    className: "st44",
    d: "M0,0l-0.1,0.1c0.1,0,0.2,0,0.3,0L0,0 M-2.1-1c0,0.2,0,0.4,0,0.6C-2-0.3-1.9-0.2-1.8-0.2 c0.1-0.1,0.3-0.3,0.5-0.4C-1.6-0.7-1.8-0.9-2.1-1 M-3.9-2.2c0.2,0.4,0.5,0.7,0.8,1c0-0.1,0-0.2,0.1-0.4C-3.3-1.8-3.6-2-3.9-2.2"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    transform: "translate(610.134 -91.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    className: "st41",
    d: "M0,0c0,0.9-0.7,1.6-1.6,1.6S-3.2,0.9-3.2,0s0.7-1.6,1.6-1.6l0,0C-0.7-1.6,0-0.9,0,0L0,0"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1360",
    transform: "translate(610.623 -93.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    className: "st41",
    d: "M0,0c0,0.4-0.3,0.7-0.7,0.7S-1.4,0.4-1.4,0l0,0c0-0.4,0.3-0.7,0.7-0.7l0,0 C-0.3-0.7,0-0.4,0,0"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    transform: "translate(461.914 -80.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    className: "st12",
    d: "M0,0h49.8v-63.6L-1.7-52.3v47.2h1.8L0,0L0,0z"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1362",
    transform: "translate(577.355 -85.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    className: "st45",
    d: "M0,0l-65.6-1.3v6H0V0z"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1363",
    transform: "translate(461.914 -80.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    className: "st20",
    d: "M0,0h49.8v-6L0-5.1V0z"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1364",
    transform: "translate(461.917 -85.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    className: "st46",
    d: "M0,0L0,0L0,0z"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1365",
    transform: "translate(511.718 -86.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    className: "st47",
    d: "M0,0L0,0v1.8l0,0V0L0,0z"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1366",
    transform: "translate(461.918 -85.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    className: "st48",
    d: "M0,0v1.5l0,0V0 M49.8-0.9L37.7-0.7V1l12.1-0.2L49.8-0.9z"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    transform: "translate(511.731 -86.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    className: "st47",
    d: "M0,0v1.8l5.3,0.1l1.1-1.7L0,0z"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    transform: "translate(579.038 -85.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    className: "st11",
    d: "M0,0l-67.3-1.4V-59L0-44.1V0z"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1369",
    transform: "translate(562.057 -109.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    className: "st12",
    d: "M0,0l9.4,1.1v-11.9L0-12.4V0z"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1370",
    transform: "translate(543.841 -111.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    className: "st12",
    d: "M0,0l10.7,1.3v-12.7L0-13.3V0z"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1371",
    transform: "translate(522.549 -114.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    className: "st12",
    d: "M0,0l12.3,1.5v-13.7L0-14.3V0z"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1372",
    transform: "translate(562.038 -80.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    className: "st12",
    d: "M0,0h9.4v-22.3L0-23.2V0z"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    transform: "translate(543.826 -92.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    className: "st12",
    d: "M0,0l10.7,0.5v-12.8L0-13.4V0z"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    transform: "translate(522.533 -93.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    className: "st12",
    d: "M0,0l12.3,0.6v-13.8L0-14.5V0z"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    transform: "translate(522.544 -107.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    className: "st49",
    d: "M0,0v1l11.1,1l1.3-0.8L0,0z"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    transform: "translate(522.557 -127.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    className: "st50",
    d: "M0,0v-1.1L12.3,1L11,1.8L0,0z"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1377",
    transform: "translate(543.848 -123.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    className: "st50",
    d: "M0,0v-1.1l10.7,1.9L9.4,1.6L0,0z"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    transform: "translate(554.545 -104.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    className: "st49",
    d: "M0,0l-1.3,0.8L-10.7,0v-1L0,0z"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    transform: "translate(571.47 -102.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    className: "st49",
    d: "M0,0l-1.3,0.8L-9.5,0v-1L0,0z"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    transform: "translate(571.484 -119.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    className: "st50",
    d: "M0,0l-1.3,0.8l-8.2-1.4v-1.1L0,0z"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    transform: "translate(499.676 -118.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    className: "st51",
    d: "M0,0l-28.8,4v34.2H0V0z"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    transform: "translate(473.597 -113.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    className: "st50",
    d: "M0,0l26.1-3.4V33H0V0z"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    transform: "translate(473.597 -113.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    className: "st51",
    d: "M0,0l-2.8-1.2l28.8-4v1.8L0,0z"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    transform: "translate(534.882 -106.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    className: "st49",
    d: "M0,0l-12.3-1.2v-6.6L0-6.3V0z"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    transform: "translate(554.545 -104.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    className: "st49",
    d: "M0,0l-10.7-1v-6L0-5.8V0z"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    transform: "translate(571.47 -102.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    className: "st49",
    d: "M0,0l-9.4-0.9v-5.5L0-5.3V0z"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    transform: "translate(499.678 -121.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    className: "st11",
    d: "M0,0l-14-1.9V1L0,2.7V0z"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    transform: "translate(470.826 -114.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    className: "st51",
    d: "M0,0l28.9-4l-14-1.8l-28.5,4.3L0,0z"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1389",
    transform: "translate(457.167 -116.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    className: "st27",
    d: "M0,0l28.5-4.3v-2.9L0-2.5V0z"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1390",
    transform: "translate(554.547 -108.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    className: "st50",
    d: "M0,0l-10.7-1.2v-1.4L0-1.3V0z"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1391",
    transform: "translate(554.545 -106.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    className: "st50",
    d: "M0,0l-10.7-1.1v-1.4L0-1.3V0z"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    transform: "translate(554.545 -104.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    className: "st50",
    d: "M0,0l-10.7-1v-1.4L0-1.3V0z"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    transform: "translate(571.476 -106.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    className: "st50",
    d: "M0,0l-9.4-1.1v-1.3L0-1.2V0z"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    transform: "translate(571.474 -104.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    className: "st50",
    d: "M0,0l-9.4-1v-1.3L0-1.2V0z"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    transform: "translate(571.47 -102.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    className: "st50",
    d: "M0,0l-9.4-0.9v-1.3l9.4,1V0z"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1396",
    transform: "translate(534.885 -111.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    className: "st50",
    d: "M0,0l-12.3-1.4V-3L0-1.5V0z"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    transform: "translate(534.882 -108.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    className: "st50",
    d: "M0,0l-12.3-1.3v-1.5L0-1.5V0z"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1398",
    transform: "translate(534.882 -106.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    className: "st50",
    d: "M0,0l-12.3-1.2v-1.5L0-1.5V0z"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    transform: "translate(499.673 -116.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    className: "st52",
    d: "M0,0v15.5l0,0V0z"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    transform: "translate(499.673 -116.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    className: "st53",
    d: "M0,0l-6.7,0.9l-10.6,15.8L0,15.5V0z"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    transform: "translate(460.173 -132.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    className: "st51",
    d: "M0,0h-5.5l57.1-15.7l71.3,18.9l-4,0.4l-67.3-15L0,0z"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    transform: "translate(570.196 -80.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    className: "st50",
    d: "M0,0h-8.2v-22.2L0-21.4V0z"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1403",
    transform: "translate(483.128 -90.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    className: "st54",
    d: "M0,0l5.5-0.2V-1L0-0.7V0z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirtyEnergyNoSmoke);
export default __webpack_public_path__ + "static/media/DirtyEnergyNoSmoke.cb93c473df52c9c2f9d1383a2e85c28c.svg";
export { ForwardRef as ReactComponent };